var map = {
	"./account.svg": "lNpt",
	"./account_active.svg": "RWU5",
	"./account_white.svg": "u+e7",
	"./arrow.svg": "nCIC",
	"./back.svg": "RN8c",
	"./cases.svg": "fkzu",
	"./cases_active.svg": "E/EZ",
	"./cases_white.svg": "0Prm",
	"./close.svg": "toIl",
	"./collections.svg": "/GFm",
	"./collections_active.svg": "eRcs",
	"./collections_white.svg": "Q8FH",
	"./display.svg": "ebzu",
	"./display_active.svg": "ZS+y",
	"./display_white.svg": "NUwL",
	"./filter.svg": "ObMl",
	"./header_back.svg": "Ijkd",
	"./header_close.svg": "icjr",
	"./heart.svg": "q9dO",
	"./home.svg": "U9Ws",
	"./home_active.svg": "kH3i",
	"./home_white.svg": "I+M7",
	"./menu.svg": "dH9r",
	"./position.svg": "3sTt",
	"./refresh.svg": "SLu3",
	"./scan.svg": "9oqM",
	"./scan_red.svg": "xjbE",
	"./search.svg": "Bx0U",
	"./search0.svg": "WhGc",
	"./search2.svg": "ZARz",
	"./search3.svg": "TQF1",
	"./sort.svg": "pr7m",
	"./star.svg": "60zo",
	"./triangle.svg": "n/kJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 54